import { render, staticRenderFns } from "./wanjiejingpingengduo.vue?vue&type=template&id=3d63f59e&scoped=true"
import script from "./wanjiejingpingengduo.vue?vue&type=script&lang=js"
export * from "./wanjiejingpingengduo.vue?vue&type=script&lang=js"
import style0 from "./wanjiejingpingengduo.vue?vue&type=style&index=0&id=3d63f59e&prod&lang=css"
import style1 from "./wanjiejingpingengduo.vue?vue&type=style&index=1&id=3d63f59e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d63f59e",
  null
  
)

export default component.exports